module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fa5fc4fd0867378d64ecfdf3ebdb3fde.png";